  
import React from "react";

import "./Options.css";

const Options = (props) => {
  const options = [
    {
      text: "📱Contact Me📱 ",
      handler: props.actionProvider.handleJavascriptQuiz,
      id: 1,
    },
    { text: "🍚My favourite food🍝 ", handler: props.actionProvider.handleFood, id: 2 },
    { text: "🍷 My favourite wine 🍷", handler: () => {}, id: 3 },
    { text: "😊 What I can do?", handler: () => {}, id: 4 }
  ];

  const buttonsMarkup = options.map((option) => (
    <button key={option.id} onClick={option.handler} className="option-button">
      {option.text}
    </button>
  ));

  return <div className="options-container">{buttonsMarkup}</div>;
};

export default Options;